import { render, staticRenderFns } from "./logisticsChannelModal.vue?vue&type=template&id=4534f50a"
import script from "./logisticsChannelModal.vue?vue&type=script&lang=js"
export * from "./logisticsChannelModal.vue?vue&type=script&lang=js"
import style0 from "./logisticsChannelModal.vue?vue&type=style&index=0&id=4534f50a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports